module.exports = __webpack_public_path__ + "static/frn-wlc-ah.6886812e.svg";